<template>
  <v-container>
    <h6 class="text-h6">Our Services</h6>
    <p class="text-subtitle-1">
      We offer a wide range of services to our customers.
    </p>
    <v-sheet rounded="lg" color="white" class="pa-4 px-10 mt-2">
      <v-row align="stretch" class="my-2 py-2">
        <template v-for="card in cards">
          <v-col
            :key="card.title"
            v-if="!card.disabled.includes(userCountry)"
            cols="12"
            :md="getColLength"
          >
            <div class="bg-white rounded-lg p-4 border border-solid border-gray-200 h-full">
              <div class="flex items-center justify-center gap-4">
                <img
                  :src="card.image"
                  alt="card.title"
                  class="w-52 h-52 rounded-lg"
                />
              </div>
              <h6 class="mt-8 text-xl font-medium text-center">
                {{ card.title }}
              </h6>
              <div class="mt-4">
                <v-btn
                  :to="card.href"
                  color="accent"
                  class="text-white"
                  width="100%"
                  flat
                >
                  {{ card.btnTitle }}
                </v-btn>
              </div>
            </div>
          </v-col>
        </template>
      </v-row>
    </v-sheet>
  </v-container>
</template>

<script>
import card from '../../../assets/img/cards.341766b6.png'
// import refill from '../../../assets/img/refill.fe9b7b69.png'
import cryto from '../../../assets/img/cryto.png'

import PayBillImage from '../../../assets/img/pay-your-bills.jpeg'
import AirtimeToCashImage from '../../../assets/img/airtime-to-cash.jpeg'
import { mapState } from 'vuex'
import { COUNTRIES } from '../../../utils/countryHelpers'
export default {
  components: {},
  data: () => ({}),
  created() {
    this.$store.dispatch('user/getSiteSettings')
  },
  computed: {
    ...mapState({
      siteData: (state) => state.user.siteSettings,
      getColLength() {
        switch (this.userCountry) {
          case COUNTRIES.GH:
            return '6'
          case COUNTRIES.KE:
            return '6'
          default:
            return '4'
        }
      }
    }),
    cards() {
      return [
        {
          image: card,
          title: 'Giftcards',
          href: '/user/products/giftcards',
          btnTitle: 'Trade',
          disabled: [],
          status: true
        },
        {
          image: cryto,
          title: 'Cryptocurrency',
          href: '/user/products/crypto',
          btnTitle: 'Trade',
          disabled: [],
          status: true
        },
        {
          image: PayBillImage,
          title: 'Pay Bills',
          href: '/user/products/bill-payment',
          btnTitle: 'Pay Bills',
          disabled: [COUNTRIES.GH, COUNTRIES.KE],
          status: true
        },
        {
          image: AirtimeToCashImage,
          title: 'Airtime to Cash',
          href: '/user/products/bills/convert-airtime/',
          message: this.siteData.airtimeToCashFeatureMessage,
          btnTitle: 'Convert Now',
          disabled: [COUNTRIES.GH, COUNTRIES.KE, COUNTRIES.NG],
          status: this.siteData.airtimeToCashFeatureAvailable || false
        }
      ]
    }
  }
}
</script>

<style></style>
